export const THEME_VARIANT = 'theme'

export const ERROR_VARIANT = 'error'

export const TABLE_VARIANT = 'table'

export const DEFAULT_MAX_COUNT = 99

export const QA_NAME_COUNTER = 'counter'
